(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["compact-review-bar"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('compact-review-bar')) {
    customElements.define('compact-review-bar', class extends HTMLElement {
      connectedCallback() {
        this.items = [...this.querySelectorAll('[data-review-item]')];
        this.mobile = window.matchMedia('(max-width: 699px)');
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.index = 1;
        this.abort = new AbortController();
        this.mobile.addEventListener('change', () => {
          this.items.forEach(item => item.getAnimations().forEach(animation => animation.cancel()));
          this.update();
        }, {signal: this.abort.signal});
        this.setAttribute('data-ready', '');
        this.update();
        this.timer = window.setInterval(() => {
          if (this.mobile.matches && !document.hidden && !this.contains(document.activeElement)) this.next();
        }, 5000);
      }
      next() {
        const outgoing = this.items[this.index];
        this.index = (this.index + 1) % this.items.length;
        const incoming = this.items[this.index];
        this.update();
        if (!this.motion.matches) {
          const options = {duration: 450, easing: 'cubic-bezier(.25,.1,.25,1)'};
          outgoing.animate([{transform: 'translateX(0)'}, {transform: 'translateX(-100%)'}], options);
          incoming.animate([{transform: 'translateX(100%)'}, {transform: 'translateX(0)'}], options);
        }
      }
      update() {
        this.items.forEach((item, index) => {
          const hidden = this.mobile.matches && index !== this.index;
          item.setAttribute('aria-hidden', String(hidden));
          item.inert = hidden;
        });
      }
      disconnectedCallback() { clearInterval(this.timer); this.abort?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
